<template>
  <div>
    <gmz-census />
  </div>
</template>

<script>
// 获取接口地址
import GmzCensus from '../components/tjbb/gmzCensus.vue'

export default {
  name: 'Gmzsyqktj',
  components: {
    // sideMenu,
    // Header,
    GmzCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
